
<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent max-width="900px" transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title class="py-3">
          <div class="headline mb-0">Detalhes de {{ trace_kind_map[trace.kind]}}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div>
            <!-- {{data_element.id}} -->
            <component :is="trace_kind_info_map[[trace.kind]]" :info="data_element" v-if="data_element.id && trace_kind_info_map[[trace.kind]]"></component>
          </div>

          <div class="mt-3">
            <b>{{ trace.type == 'vrt_transaction' ? 'Pagamentos' : 'Faturas' }} relacionados</b>
          </div>

          <template v-if="loading">
            <v-alert type="info" :value="true">
              Carregando...
              <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
            </v-alert>
          </template>
          <template v-if="!loading && traces.length == 0">
            <v-alert type="info" :value="true">
              Sem nenhum registro de {{ trace.type == 'vrt_transaction' ? 'pagamentos' : 'faturas' }}
            </v-alert>
          </template>
          <template v-if="!loading && traces.length != 0">
            <list-item-trace :list_of="list_of" :hf="trace" :traces="traces" @orderClicked="orderClicked"
              @detailsClick="handleDetailsClick"></list-item-trace>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn close @click="dialog = false"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-item-trace :list_of="one_trace.type" :trace="one_trace" @orderClicked="orderClicked" v-if="dialog_details"
      @close='handleClose'></dialog-item-trace>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ListItemTrace from './ListItemTrace.vue'
import Api from '@/api/index';

export default {
  name: 'DialogItemTrace',
  components: {
    ListItemTrace,
    InfoBill: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoBill.vue'),
    InfoCash: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoCash.vue'),
    InfoCheck: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoCheck.vue'),
    InfoDeposit: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoDeposit.vue'),
    InfoPix: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoPix.vue'),
    InfoVrtTrans: () => import('@/_backoffice/_registrations/components/client/pay_traces/item_info/InfoVrtTrans.vue'),
  },
  props: {
    trace: {
      type: Object,
    },
    element: {
      type: Object,
    },
    list_of: {
      type: String,
    }
  },
  data() {
    return {
      dialog: true,
      traces: [],
      loading: false,
      data_element: {},
      element_type_map: {
        vrt_transaction: {
          module: "VrtTransaction",
          action: 'show'
        },
        deposit: {
          module: "Deposit",
          action: 'show'
        },
        check: {
          module: "Check",
          action: 'show'
        },
        cash: {
          module: "Cash",
          action: 'show'
        },
        bill: {
          module: "Bill",
          action: 'show'
        },
        pix: {
          module: "Pix",
          action: 'show'
        },
      },
      list_of_map: {
        vrt_transaction: "payment",
        payment: "vrt_transaction",
      },

      trace_kind_map: {
        vrt_transaction: "Fatura",
        deposit: "Depósito",
        check: "Cheque",
        cash: "Dinheiro",
        bill: "Boleto",
        pix: "PIX",
        client_credit: "Crédito/Bônus",
      },
      trace_kind_info_map: {
        vrt_transaction: "InfoVrtTrans",
        deposit: "InfoDeposit",
        check: "InfoCheck",
        cash: "InfoCash",
        bill: "InfoBill",
        pix: "InfoPix",
      },

      one_trace: {},

      dialog_details: false,
    }
  },
  methods: {
    orderClicked(order_id) {
      this.$emit('orderClicked', order_id)
    },
    handleDetailsClick(e){
      // console.log({e});
      this.dialog_details = true 
      this.one_trace = {...e}
    },
    handleClose() {
      this.dialog_details = false
      this.one_trace = {}
    },
    getElement(){
      if (this.element_type_map[this.trace.kind]){
        const {module, action} = this.element_type_map[this.trace.kind]
        Api[module][action](this.trace.id).then(r=>r.data).then(d=> {
          d = d.data ? d.data.attributes : d
          this.data_element = {...d}
        })
      }
    },
    getTraces() {
      if (this.traces.length == 0) {
        this.loading = true
        let filter = {}
        // console.log(this.trace);
        if (this.trace.type == 'payment'){
          filter.trace_type = this.trace.kind 
          filter.trace_id = this.trace.id
        } else if (this.trace.type == 'vrt_transaction') {
          filter.by_vrt_id = this.trace.id
        }
        Api.PayTrace.index(filter).then(r => r.data).then(d => {
          this.traces = [...d, ...this.traces]
        }).finally(() => {
          this.loading = false
        })
      }
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted() {
    this.getTraces();
    this.getElement()
  },
  watch: {
    dialog(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        this.$emit('close')
      }
    }
  },
}
</script>

<style scoped>

</style>